<template>
    <div>
        <div style="width: 124px;display: inline-block" class="requiredLabel" v-if="title === 'SuggestedPrice'">{{ $t('publishEdit.SuggestedPrice') }}</div>
        <div style="width: 122px;display: inline-block" v-else>{{ $t('publishEdit.CompareAtPrice') }}</div>
        <el-popover
            placement="bottom"
            width="520"
            trigger="click"
            v-model="visible">
            <div style="padding: 30px 18px 15px;">
                <el-radio-group v-model="radioValue" @change="radioValueChange" style="margin-bottom: 20px">
                    <el-radio :label="1" ref="shippingCostRadioRef1">{{$t('publishEdit.Percentage')}}</el-radio>
                    <el-radio :label="2" ref="shippingCostRadioRef3">{{$t('publishEdit.FixedProfit')}}</el-radio>
                    <el-radio :label="3" ref="shippingCostRadioRef2">{{$t('publishEdit.OneClickModification')}}</el-radio>
                </el-radio-group>
                <div v-if="radioValue === 1" style="margin-bottom: 30px" >
                    <div style="margin-bottom: 8px">
                        <el-input
                        style="width: 250px"
                        :placeholder="$t('publishEdit.ProfitMargin')"
                        class="infoInput"
                        v-model="PercentageV"
                        @input="value => PercentageV = value.replace(/[^\d.]/g, '')"
                        @blur="value => priceInputBlur(value, 'PercentageV')"></el-input> %
                    </div>
                    <div style="color: #747A87;font-size: 12px">
                        {{ title === 'SuggestedPrice' ? $t('publishEdit.SuggestedPriceTips1') : $t('publishEdit.CompareAtPriceTips1')}}
                    </div>
                </div>
                <div v-else-if="radioValue === 2" style="margin-bottom: 30px" >
                  <div style="margin-bottom: 8px">
                    <el-input
                    style="width: 250px"
                    :placeholder="$t('publishEdit.Profi')"
                    class="infoInput"
                    v-model="fixedProfit"
                    @input="value => fixedProfit = value.replace(/[^\d.]/g, '')"
                    @blur="value => priceInputBlur(value, 'fixedProfit')"></el-input>{{ currency }}
                  </div>
                  <div style="color: #747A87;font-size: 12px">
                    {{ title === 'SuggestedPrice' ? $t('publishEdit.SuggestedPriceTips4') : $t('publishEdit.CompareAtPriceTips2')}}
                  </div>
                </div>
                <div v-else style="margin-bottom: 30px">
                    <div style="margin-bottom: 8px">
                        {{ $t('publishEdit.NewPrice') }}：
                        <el-input
                        style="width: 250px"
                        placeholder="Input Content"
                        class="infoInput"
                        v-model="OneClickModificationV"
                        @input="value => OneClickModificationV = value.replace(/[^\d.]/g, '')"
                        @blur="value => priceInputBlur(value, 'OneClickModificationV')"></el-input>
                        {{ currency }}
                    </div>
                    <div style="color: #747A87;font-size: 12px;padding-left: 100px">
                        {{$t('publishEdit.SuggestedPriceTips3')}}
                    </div>
                </div>
                <div style="text-align: right; margin: 0">
                    <el-button @click="btnClick('cancel')">{{$t('publishEdit.cancel')}}</el-button>
                    <el-button type="primary" @click="btnClick('confirm')">{{$t('publishEdit.confirm')}}</el-button>
                </div>
            </div>
            <i class="el-icon-edit" style="cursor: pointer;font-size: 15px" slot="reference"></i>
        </el-popover>
    </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    currency: {
      type: String,
      default: () => 'USD'
    }
  },
  data() {
    return {
      radioValue: 1,
      visible: false,
      PercentageV: undefined,
      OneClickModificationV: undefined,
      fixedProfit: undefined
    }
  },
  methods: {
    radioValueChange(label) {
    },
    btnClick(type) {
      if (type === 'cancel') {
        this.visible = false
      } else {
        let final; let which
        if (this.radioValue === 1) {
          final = ((this.PercentageV / 100) + 1)
          which = 'PercentageV'
        } else if (this.radioValue === 2) {
          final = this.fixedProfit
          which = 'FixedProfit'
        } else {
          final = this.OneClickModificationV
          which = 'OneClickModificationV'
        }
        this.$emit('change', { final, which, title: this.title })
        this.PercentageV = undefined
        this.OneClickModificationV = undefined
        this.fixedProfit = undefined
        this.visible = false
      }
    },
    // 输入框失去焦点  小数点保留两位
    priceInputBlur(value, which) {
      if (value.target.value) {
        this[which] = parseFloat(parseFloat(value.target.value).toFixed(2))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.requiredLabel::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
</style>
